import type { ReactNode } from "react";

type PaymentInformationCardProps = {
  title: string;
  value: string;
  icon: ReactNode;
};

export const PaymentInformationCard = ({ icon, title, value }: PaymentInformationCardProps) => {
  return (
    <div className="flex items-center gap-3 rounded-xl bg-canvas p-4 text-sm">
      <div className="flex aspect-square w-9 items-center justify-center rounded-xl bg-surface-inverted text-content-on-inverted">
        {icon}
      </div>
      <div className="flex flex-col gap-1">
        <p className="font-semibold">{title}</p>
        <p className="text-content-secondary">{value}</p>
      </div>
    </div>
  );
};
